export default class Stack {
  constructor() {
    // @ts-ignore
    this.storage = [];
  }

  push(element: any) {
    // @ts-ignore
    this.storage.push(element);
  }

  pop() {
    if (this.isEmpty()) {
      return null;
    }

    // @ts-ignore
    return this.storage.pop();
  }

  isEmpty() {
    // @ts-ignore
    return this.storage.length === 0;
  }
}
